import { useEffect } from "react"

import { createContextMenuHandler, subscribeOnContextMenu } from "utils/ContextMenuTracker"

export function useReportPsychologistNameCopy(name: string, from: string) {
    useEffect(() => {
        const unsubscribeOnContextMenu = subscribeOnContextMenu(
            createContextMenuHandler(name, from)
        )

        return () => unsubscribeOnContextMenu()
    }, [])
}
